import { Component, Input, OnInit } from '@angular/core';
import { Section } from '@stuplay'
import { ActivatedRoute } from '@angular/router';
import { DataHelper } from '../../../utils/helpers';

@Component({
    selector: 'msc-section-presentation',
    templateUrl: './section-presentation.component.html',
    styleUrls: ['./section-presentation.component.less']
})
export class SectionPresentationComponent implements  OnInit {
    @Input() section: Section;

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        this.route.paramMap.subscribe(() => {
            this.section = this.route.snapshot.data['section'];
        });
    }

    navigate(section: any): any {
        if (section?.sectionContents[0]?.context === 'external_link') {
            return ['external-link', section?.sectionContents[0][DataHelper.changeCase(section?.sectionContents[0]?.context, 'camel')]?.id];
        } else {
            return [section?.sectionContents[0]?.context, section?.sectionContents[0][DataHelper.changeCase(section?.sectionContents[0]?.context, 'camel')]?.id];
        }
    }

    /**
     * Ruta (relativa a la sección actual) hacia un contenido concreto, replicando
     * el comportamiento de navegación del sidebar para la lista "Lo que verás".
     */
    navigateContent(sectionContent: any): any[] {
        switch (sectionContent?.context) {
            case 'media':
                return ['media', sectionContent?.media?.id, 'content', sectionContent?.id];
            case 'external_link':
                return ['external-link', sectionContent?.externalLink?.id];
            case 'exercise':
                return ['exercise', sectionContent?.exercise?.id, 'question', sectionContent?.exercise?.questions?.[0]?.id];
            default:
                return [sectionContent?.context, sectionContent?.[DataHelper.changeCase(sectionContent?.context, 'camel')]?.id];
        }
    }

    /**
     * Clave lógica de icono para cada contenido (mismo criterio que el sidebar).
     */
    getContentIconKey(sectionContent: any): string {
        const context = sectionContent?.context;
        if (context === 'media') {
            const m = sectionContent?.media;
            const type = (m?.type || m?.kind || '').toString().toLowerCase();
            const mime = (m?.mimeType || m?.mime || '').toString().toLowerCase();
            if (type.includes('video') || mime.includes('video')) { return 'video'; }
            if (type.includes('audio') || mime.includes('audio')) { return 'audio'; }
            if (type.includes('pdf') || mime.includes('pdf')) { return 'pdf'; }
            if (type.includes('image') || mime.includes('image')) { return 'image'; }
            return 'media';
        }
        switch (context) {
            case 'cheatsheet': return 'document';
            case 'discussion': return 'discussion';
            case 'exchange': return 'exchange';
            case 'event': return 'event';
            case 'project':
            case 'selfassessment': return 'project';
            case 'scorm':
            case 'scormcloud': return 'scorm';
            case 'external_link': return 'link';
            case 'certificate': return 'certificate';
            case 'exercise': return 'exercise';
            default: return 'default';
        }
    }
}
